<template>
  <div class="content-wrapper">
    <app-page-top-section :title="$t('all_pages')" icon="briefcase">
      <app-default-button btn-class="btn btn-success mr-2"
                          :title="$fieldTitle('add', 'page', true)"
                          @click="openModal()"
                          v-if="$can('add_page')"
      />
    </app-page-top-section>

    <app-table
        id="pages-table"
        :options="options"
        :card-view="false"
        @reload="reloadPageTable"
        @getRows="getSelectedRows"
        @action="triggerActions"
    />

    <app-page-create-edit-modal
        v-if="isLocationCreateOpenModalActive || isModalActive"
        v-model="isModalActive"
        :selected-url="selectedUrl"
        @close="isModalActive = false"
    />
    <!--        :subPackage="subscriptionPackage"-->

    <app-confirmation-modal
        v-if="confirmationModalActive"
        icon="trash-2"
        modal-id="app-confirmation-modal"
        @confirmed="confirmed('pages-table')"
        @cancelled="cancelled"
    />

  </div>
</template>

<script>
// import PackageCreateEditModal from "./PackageCreateEditModal";

import {CREATE_PAGE} from "../../../Config/ApiUrl";
import PageMixin from "../../Mixins/PageMixin";
import PageCreateEditModal from "./PageCreateEditModal";
export default {
  name: 'Pages',
  components: {PageCreateEditModal},
  mixins: [PageMixin],
  data() {
    return {
      isModalActive: false,
      selectedUrl: '',
      isLocationCreateOpenModalActive: false,
      subscriptionPackage: [],
    }
  },
  methods: {
    openModal() {
      this.isModalActive = true;
      this.selectedUrl = ''
    },
    triggerActions(row, action, active) {
      this.subscriptionPackage = row;
      if (action.title === this.$t('edit')) {
        this.selectedUrl = `${CREATE_PAGE}/${row.id}`;
        this.isModalActive = true;
      }
      else {
        this.getAction(row, action, active)
      }
    },
  }
}
</script>
